import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import globalRelay from '../globalRelay';
import util from '../util';
import jobFactory from '../models/jobModel';
import * as jobActions from '../jobActions';import enums from '../enum';
import componentServices from '../componentServices';

import { ContextMenu, AsyncContent, Expander, JobSearchResults, Popup, sortableComponent } from './sharedComponents';
import JobSearchForm from './jobSearchForm';
import NewJobWorkflow from './newJobWorkflow';
import { getCollection, getModel, ModelCollection } from '../store';

const Table = sortableComponent(({ updateSort, sortKey, list, ...childProps }) => {
	const rows:JSX.Element[] = [];

	list.forEach((item) => {
		rows.push(<TableRow item={item} key={item.key} {...childProps} />);
	});

	return (
		<table className="sortable interactive" cellPadding="0" cellSpacing="0">
			<TableHeader updateSort={updateSort} sortKey={sortKey} {...childProps} />
			<tbody>
				{rows}
			</tbody>
		</table>
	);
});

class TableHeader extends React.Component<any,any> {
	handleClick (path, e) {
		e.preventDefault();
		this.props.updateSort(path);
	}
	getClassName (key, classes = [] as string[]) {
		if (key === this.props.sortKey) {
			classes.push('sorted');
		}
		return classes.join(' ');
	}
	render () {
		const { sortDateLabel } = this.props;

		return (
			<thead>
				<tr>
					<td />
					<td className={ this.getClassName('sortDate', ['date'])} onClick={this.handleClick.bind(this, 'sortDate')}>{ sortDateLabel }</td>
					<td className={this.getClassName('leadContactName', ['name'])} onClick={this.handleClick.bind(this, 'leadContactName')}>Client</td>
					<td className={this.getClassName('leadSource')} onClick={this.handleClick.bind(this, 'leadSource')}>Lead Source</td>
					<td className={this.getClassName('employeeName', ['name'])} onClick={this.handleClick.bind(this, 'employeeName')}>Salesperson</td>
					<td className="action" />
					<td />
				</tr>
			</thead>
		);
	}
}

class TableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
		this.handleContextMenuClick = this.handleContextMenuClick.bind(this);
	}
	handleClick (e) {
		const { item } = this.props;

		e.preventDefault();

		componentServices.router.pushHistory(componentServices.router.splicePathSegments(1, 1, 'jobs', item.key, 'client'));
	}
	setAccountManager (employee?) {
		const { store } = componentServices;
		const { item } = this.props;
		const job = getModel({ store, collection: ModelCollection.jobs, key: item.key });
		const updateTarget = jobFactory(job.toDocument());

		updateTarget.accountManagerKey = employee && employee.key;

		let patch = updateTarget.getPatch(job);

		if (patch.length) {
			updateTarget.setSetting(enums.jobSettingGroups.Marketing, 'leadAssigned', updateTarget.accountManagerKey);
			patch = updateTarget.getPatch(job);
			jobActions.saveJob({ job: updateTarget, patch: patch });
		}
	}
	handleContextMenuClick (e) {
		const { store } = componentServices;
		const { item } = this.props;
		const employees = getCollection({ store, collection: ModelCollection.employees });
		const globalConfig = globalRelay.config!;
		const roleTitleTests = globalConfig.systemRoleEmployeeTitleTests;
		const designerTests = roleTitleTests.designer;
		const designers = employees.filter(employee => {
			return _.reduce(designerTests, (r, v) => {
				if (!r) {
					const test = new RegExp(v, 'i');
					r = test.test(employee.orgTitleKey);
				}
				return r;
			}, false);
		}).sortBy(employee => employee.fullName);

		e.stopPropagation();

		const menuItems:any[] = [];
		menuItems.push({ label: 'None', className: typeof item.accountManagerKey === 'undefined' ? 'on' : '', action: () => {
			this.setAccountManager();
			actions.popModal();
		} });

		designers.forEach(d => {
			menuItems.push({ label: d.fullName, className: item.accountManagerKey === d.key ? 'on' : '', action: () => {
				this.setAccountManager(d);
				actions.popModal();
			} });
		});

		const popup = <Popup target={e.target}><ContextMenu items={ menuItems } disableIcons={ true } /></Popup>;

		actions.pushModal({ component: popup });
	}
	render () {
		const { item } = this.props;

		return (
			<tr onClick={ this.handleClick }>
				<td />
				<td>{ util.dateHelper.formatDate(item.sortDate, { userFriendly: true }) }</td>
				<td>{ item.leadContactName }</td>
				<td>{ item.leadSource ? _.startCase(item.leadSource) : '-' }</td>
				<td>{ item.employeeName || '-' }</td>
				<td className="actions"><button className="icon iconOnly contextMenu" onClick={ this.handleContextMenuClick }><span /></button></td>
				<td />
			</tr>
		);
	}
}

const _searchKey = 'retail-manager-jobs-search';
export default class RetailManagerJobs extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();

		this.handleAddJobClick = this.handleAddJobClick.bind(this);
	}

	componentDidMount () {
		jobActions.fetchJobsByCriteria({ retailLeads: {}});

		actions.setHeaderAction({
			key: 'job-add-action-retail-manage',
			element: <button className="icon addPerson" onClick={this.handleAddJobClick}><span /></button>
		});
	}

	componentWillUnmount () {
		actions.deleteHeaderAction({ key: 'job-add-action-retail-manage' });
	}

	shouldComponentUpdate (nextProps, nextState) {
		return this.props !== nextProps || this.state !== nextState;
	}

	UNSAFE_componentWillReceiveProps () {
		this.setState(this.getStateFromProps());
	}

	getStateFromProps () {
		const { store } = componentServices;
		const state = _.assign({}, this.state);
		const storeJobs = getCollection({ store, collection: ModelCollection.jobs });
		const cutoff = Date.now() - (1000 * 60 * 60 * 24 * 7);

		if (state.modelJobs !== storeJobs) {
			state.modelJobs = storeJobs;
			const items:any[] = [];

			storeJobs.filter(j => j.currentStatus !== 'lead-lost').forEach(j => {
				const accountManager = j.accountManagerKey && this.getEmployeeByKey(j.accountManagerKey);
				const assignmentSetting = j.getSetting(enums.jobSettingGroups.Marketing, 'leadAssigned');
				const formContact = _.head(j.getExternalFormContacts());
				const leadSource = j.leadSource;
				const sourceParts:any[] = [];

				if (leadSource) {
					sourceParts.push(leadSource);
				}

				if (formContact) {
					const contactSource = formContact.getAdditionalInfoValue('source');
					if (contactSource) {
						sourceParts.push(contactSource);
					}
				}

				if ((assignmentSetting && assignmentSetting.dateModifiedOrCreated && assignmentSetting.dateModifiedOrCreated.getTime() > cutoff) || !j.accountManagerKey) {
					items.push({
						key: j.key,
						sortDate: assignmentSetting ? assignmentSetting.dateModifiedOrCreated : j.dateCreated,
						leadContactName: j.leadContactName,
						leadSource: (sourceParts.length ? sourceParts.join(' - ') : '-'),
						accountManagerKey: accountManager && accountManager.key,
						employeeName: accountManager && accountManager.fullName
					});
				}
			});

			state.items = items;
		}

		return state;
	}

	getEmployeeByKey (key) {
		const { store } = componentServices;
		const employees = getCollection({ store, collection: ModelCollection.employees });

		return employees.find(e => e.key === key);
	}

	handleAddJobClick (e) {
		e.preventDefault();

		actions.pushModal({
			component: (<NewJobWorkflow close={ actions.popModal } initialTitle={'New Lead or Job'} businessSegment={ enums.businessSegments.Retail } />),
			rendersAlerts: true
		});
	}

	render () {
		const { items } = this.state;
		const searchResults = componentServices.store.getIn(['viewState', 'searchResults', _searchKey]);
		const dashboardClasses = ['dashboard', 'salesManager'];
		let listContent;
		const listUnnassigned = _.filter(items, i => !i.employeeName);
		const listAssigned = _.filter(items, i => !!i.employeeName);
		const titleUnnasigned = "Unnassigned Leads";
		const titleAssigned = "Recently Assigned Leads";
		const emptyTitle = "No Leads";

		if (searchResults) {
			dashboardClasses.push('searchResults');

			listContent = (<JobSearchResults
				list={ searchResults.list }
				parameterName={ searchResults.searchParameter.name }
				searchText= { searchResults.searchText }
				onJobClick= { (j) => componentServices.router.pushHistory(componentServices.router.splicePathSegments(1, 1, 'jobs', j.key, 'client')) } />);
		}
		else {
			listContent = [
				<Expander title= { titleUnnasigned } isExpanded={ true } key="unassigned">
					<AsyncContent emptyContent = { emptyTitle } hasData={ listUnnassigned.length } ><Table list={ listUnnassigned } initialSortKey="sortDate" sortDateLabel="Added On" /></AsyncContent>
				</Expander>,
				<Expander title= { titleAssigned } isExpanded={ true } key="assigned">
					<AsyncContent emptyContent = { emptyTitle } hasData={ listAssigned.length } ><Table list={ listAssigned } initialSortKey="sortDate" sortDateLabel="Assigned On" /></AsyncContent>
				</Expander>
			];
		}

		return (
			<div className={ dashboardClasses.join(' ') }>
				<JobSearchForm searchKey={ _searchKey } />
				{ listContent }
			</div>
		);
	}
}